@if (sidebar()?.open) {
  <div class="sidebar-wrapper" animate.enter="fade-in" animate.leave="fade-out">
    <div class="sidebar-header">
      @if (sidebar()?.config.title) {
        <h3>{{ sidebar()?.config.title | translate }}</h3>
      }

      <cw-action-icon [icon]="'close'" (click)="close()" font="cortex" data-vef="sidebar-close" />

      <cw-divider class="divider" axis="horizontal" type="default" />
    </div>

    @if (sidebar()?.loading?.()) {
      <div class="loader inline"></div>
    }
    <ng-container *ngComponentOutlet="sidebar()?.component; inputs: sidebar()?.inputs" />
  </div>
  <div class="overlay" (click)="close()">
    <!-- Intentionally empty
    Holds the close functionality when clicking outside the sidebar
    -->
  </div>
}
